// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.url-item[data-v-47047a0a] {\n  display: grid;\n  grid-template-columns: 2rem 1fr;\n  align-items: center;\n}\n.last-save[data-v-47047a0a] {\n  margin-top: 1rem;\n  margin-left: 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
